import React from 'react';
import { Flex, IconArrowRight, TextButton, Typography } from '@banhala/ui-kit';
import { useBeautyRecommendedOption } from '../../queries/useBeautyRecommendedOption';
import { useMyInfo } from 'shared/src/queries';
import { isNil, isNotNil } from 'shared/src/utils';
import type { GoodsOption } from 'shared/src/api/goodsService/types';
import { useIsBottomSheetGiftMode } from '../../hooks/useIsBottomSheetGiftMode';

export const OptionRecommendView: React.FC<{
  onPressSelectOption: (option: GoodsOption) => void;
}> = props => {
  const { data: recommendedOption } = useBeautyRecommendedOption();
  const { data: myInfo } = useMyInfo();
  const isGiftMode = useIsBottomSheetGiftMode();

  if (isGiftMode) return null;

  if (isNil(myInfo)) return null;

  if (isNil(recommendedOption)) return null;

  if (isNil(recommendedOption.option_component)) return null;

  return (
    <Flex.Row
      borderRadius={4}
      backgroundColor={'bg_secondary'}
      padding={{ horizontal: 16, right: 0, vertical: 16 }}
      alignItems={'center'}
      justifyContent={'space-between'}
    >
      <Flex flex={1} gap={4}>
        <Typography type={'body4'} color={'content_secondary'}>
          <Typography type={'subtitle4'} color={'content_blue_primary'}>
            {isNotNil(myInfo.skin_tone)
              ? `${myInfo.skin_tone.name} 고객`
              : '고객'}
          </Typography>
          이 가장 많이 구매한 옵션
        </Typography>
        <Typography type={'subtitle2'} numberOfLines={1}>
          {recommendedOption.option_component.goods_option.option_names.join(
            ' / ',
          )}
        </Typography>
      </Flex>
      <TextButton
        size={'small'}
        color={'black'}
        onPress={() => {
          if (isNil(recommendedOption)) return null;

          if (isNil(recommendedOption.option_component)) return null;

          props.onPressSelectOption(
            recommendedOption.option_component.goods_option,
          );
        }}
        icon={<IconArrowRight size={16} />}
      >
        즉시 선택
      </TextButton>
    </Flex.Row>
  );
};
